{
  "actions": "Ações",
  "actionsAvailable": "Ações disponíveis.",
  "clearSelection": "Limpar seleção",
  "selected": "{count, plural, =0 {Nenhum selecionado} other {# selecionado}}",
  "selectedAll": "Tudo selecionado"
}
